<template>
	<div
		style="width: 95%"
		class="ml-5 mt-4"
	>
		<loading-overlay
			:active="isLoaded"
			:can-cancel="true"
		/>
		<b-modal
			id="pickupstores-modal"
			ref="addpickupstores-modal"
			hide-footer
		>
			<template #modal-title>
				Create New Pick up Store
			</template>
			<div class="d-block text-center">
				<b-form-group
					class="form-group"
					label="Name: "
					label-for="block-form1-name"
				>
					<Field
						v-slot="{ errors }"
						v-model="PickupStoredata.name"
						rules="required"
						name="Name"
					>
						<div
							class="control"
						>
							<b-form-input
								v-model="PickupStoredata.name"
								type="text"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>
				</b-form-group>
			</div>
			<b-button
				class="mt-3"
				block
				@click="addPickupStore()"
			>
				Save
			</b-button>
		</b-modal>
		<base-block
			title="Existing pickup store"
			header-bg
		>
			<div
				ref="pickupStoreTable"
			/>
		</base-block>
	</div>
</template>

<style lang="scss">
@import "../../assets/scss/custom/errors";
</style>
